import React, { FC } from "react";
import { Box, Stack, Heading, Text, useColorMode } from "@chakra-ui/react";

const Jumbotron: FC = () => {
  const { colorMode } = useColorMode();
  const sectionBgColor = { light: "white", dark: "gray.900" };
  const sectionColor = { light: "gray.900", dark: "white" };

  return (
    <Stack
      spacing={2}
      height="calc(100vh - 100px)"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={4}
      // bgImage={`url(/images/common/background.jpg)`}
      // bgSize="cover"
      // bgPos="center"
    >
      <Box>
        <Heading
          as="h1"
          fontSize={["3rem", "4rem", "5rem", "6rem"]}
          fontFamily="body"
        >
          Clever Brainz
        </Heading>
      </Box>
      <Box>
        <Text>
          <Box as="b">Web</Box> and <Box as="b">Mobile Application Development</Box>
        </Text>
      </Box>
    </Stack>
  );
};

export default Jumbotron;
